export const contactUs = (data )=>{
const {name ,
  email ,
  phone ,
  service ,
  message } = data
return (
 ` <!doctype html>
<html lang="en">
   <head>
      <!-- Required meta tags -->
      <meta charset="utf-8">
      <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">
     
      <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap" rel="stylesheet">
      <style>
      </style>
   </head>
   <body style="background-color:#FFF1E8;font-family: 'Montserrat', sans-serif;">
      <table style="box-shadow: 0px 30px 60px #0000000d;
         border-radius: 10px;
         background-color: white;
         padding: 41px;
         max-width: 608px;
         height: 430px;
         width: 100%; text-align: center;
         margin: 0 auto;">
         <tr>
            <td>
               <h6 style="font-size: 18px;line-height: 28px; font-weight: 600;    margin-top: 0;
                  margin-bottom: 29px;">Conatct Info </h6>
                  <p>Name : ${name} <p>
                  <p>Email : ${email} <p>
                  <p>Phone : ${phone} <p>
                  <p>Service : ${service} <p>
                  <p>Message : ${message} <p>
            </td>  
         </tr>
      </table>
   </body>
</html>`
)

}